export default __webpack_public_path__ + "static/media/CharbelHbayter.639b0d81.jpeg";